__turbopack_context__.v({
  "animate": "Image360-module__uR4BLa__animate",
  "container": "Image360-module__uR4BLa__container",
  "fav": "Image360-module__uR4BLa__fav",
  "heading": "Image360-module__uR4BLa__heading",
  "icon": "Image360-module__uR4BLa__icon",
  "icons": "Image360-module__uR4BLa__icons",
  "image": "Image360-module__uR4BLa__image",
  "images": "Image360-module__uR4BLa__images",
  "initialising": "Image360-module__uR4BLa__initialising",
});
